import { Button } from 'primereact/button';
import { confirmDialog } from 'primereact/confirmdialog';
import { DataView } from 'primereact/dataview';
import { Message } from 'primereact/message';
import { useState } from 'react';
import Data from '../../../../components/Display/Data';
import DataTag from '../../../../components/Display/DataTag';
import MultiLineData from '../../../../components/Display/MultiLineData';
import Section from '../../../../components/Display/Section';
import { getConstant } from '../../../../utils/constants';
import { getImage } from '../../../../utils/imageHelper';
import DistributionItem from '../distribution/DistributionItem';
import NewsListItem from '../news/NewsListItem';

const ASPECT_RATIO = 1.71;

function ProgramDetail({
  program,
  handleUpdateProgram,
  handleUpdateDistribution,
  handleUpdateDistributionList,
  handleDeleteDistribution,
  handleDelete,
  handleCreateNews,
  handleUpdateNews,
  handleDeleteNews
}) {
  const [mainImageisValid, setMainImageisValid] = useState(true);
  const [secondaryImageIsValid, setSecondaryImageIsValid] = useState(true);

  const updateProgramActions = [
    {
      onClick: handleUpdateProgram,
      label: 'Modifier les informations',
      icon: 'pi-pencil'
    }
  ];

  const newNewsActions = [
    {
      onClick: handleCreateNews,
      label: 'Ajouter un article',
      icon: 'pi-plus'
    }
  ];

  const editionDistributionActions = [
    {
      onClick: handleUpdateDistributionList,
      label: 'Modifier la distribution',
      icon: 'pi-pencil'
    }
  ];

  const confirmDeletion = (program) => {
    confirmDialog({
      message: 'Êtes-vous sûr de vouloir supprimer ce Programme ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Oui',
      rejectLabel: 'Annuler',
      accept: () => handleDelete(program)
    });
  };

  const confirmNewsDeletion = (news) => {
    confirmDialog({
      message: 'Êtes-vous sûr de vouloir supprimer cet article ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Oui',
      rejectLabel: 'Annuler',
      accept: () => handleDeleteNews(news)
    });
  };

  // Image is valid if width == height
  const computeMainImageShape = (img) => {
    setMainImageisValid(
      (img.nativeEvent.srcElement.naturalWidth / img.nativeEvent.srcElement.naturalHeight).toFixed(
        2
      ) == ASPECT_RATIO
    );
  };

  const computeSecondaryImageShape = (img) => {
    setSecondaryImageIsValid(
      (img.nativeEvent.srcElement.naturalWidth / img.nativeEvent.srcElement.naturalHeight).toFixed(
        2
      ) == ASPECT_RATIO
    );
  };

  const newsItemTemplate = (news) => {
    return (
      <NewsListItem news={news} deleteNews={confirmNewsDeletion} updateNews={handleUpdateNews} />
    );
  };

  return (
    <div className={`h-full w-full flex-col flex gap-5`}>
      <Section label="Informations Générales" actions={updateProgramActions}>
        <div className="flex flex-wrap gap-5">
          <Data key="title" label={'Titre'} value={program.title} large />
          <DataTag
            key="status"
            label="État"
            tag={getConstant('melismes.common.statusTypes', program.status)}
            rounded
            large
          />
          <Data key="deezer_id" label={'ID Deezer'} value={program.deezer_id} large />
          <Data key="video_url" label={'URL Youtube'} value={program.video_url} large />
        </div>
        <MultiLineData
          key="description"
          label={'Description'}
          value={program.description}
          large
          asHtml
        />
      </Section>
      <div className="flex flex-wrap gap-5">
        <Section label="Image principale">
          {!mainImageisValid && program.main_image && (
            <div>
              <Message
                severity="warn"
                text={`Cette image n'est pas au ratio ${ASPECT_RATIO}:1, l'affichage sur le site ne sera pas optimal.`}
              />
            </div>
          )}
          <img
            onLoad={computeMainImageShape}
            className="w-96"
            src={program.main_image ? program.main_image.file : getImage('img-ph.png')}
            alt={program.main_image ? program.main_image.label : 'Non renseignée'}
          />
        </Section>
        <Section label="Image secondaire">
          {!secondaryImageIsValid && program.secondary_image && (
            <div>
              <Message
                severity="warn"
                text={`Cette image n'est pas au ratio ${ASPECT_RATIO}:1, l'affichage sur le site ne sera pas optimal.`}
              />
            </div>
          )}
          <img
            onLoad={computeSecondaryImageShape}
            className="w-96"
            src={program.secondary_image ? program.secondary_image.file : getImage('img-ph.png')}
            alt={program.secondary_image ? program.secondary_image.label : 'Non renseignée'}
          />
        </Section>
      </div>
      <Section label="Distribution" actions={editionDistributionActions}>
        {program.distributions?.length > 0 ? (
          <div className="flex flex-col gap-3">
            {program.distributions.map((distrib, id) => (
              <DistributionItem
                key={id}
                distribution={distrib}
                handleUpdateDistribution={() => handleUpdateDistribution(distrib)}
                handleDeleteDistribution={() => handleDeleteDistribution(distrib)}
              />
            ))}
          </div>
        ) : (
          <p className="italic text-slate-400 font-light">Non renseignée</p>
        )}
      </Section>

      <Section label="Articles de presse" actions={newNewsActions}>
        <DataView
          value={program.news}
          itemTemplate={newsItemTemplate}
          emptyMessage="Aucun article à afficher"
        />
      </Section>

      <Section label="Autres actions">
        <div className="flex flex-row">
          <Button
            key={'delete'}
            label={'Supprimer le programme'}
            className="!w-54"
            outlined
            onClick={() => confirmDeletion(program)}
            severity="danger"
          />
        </div>
      </Section>
    </div>
  );
}

export default ProgramDetail;
